"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { getAuthStatus } from "@/server-action/auth/get-auth-status";

export function useAuth(initialIsLoggedIn: boolean = false) {
  const [isLoggedIn, setIsLoggedIn] = useState(initialIsLoggedIn);
  const pathname = usePathname();

  useEffect(() => {
    let cancelled = false;
    getAuthStatus()
      .then(({ isLoggedIn }) => {
        if (!cancelled) setIsLoggedIn(isLoggedIn);
      })
      .catch(() => {
        if (!cancelled) setIsLoggedIn(false);
      });
    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return { isLoggedIn };
}
